export default __webpack_public_path__ + "static/screenshot-target-scores-779a42acefb429047db0e45fb4250a0f.png";